import { Reveal } from "./Reveal";
import PillButton from "./PillButton";
import {
    ADDRESS,
    HOURS,
    MAPS_EMBED,
    MAPS_URL,
    PHONE_DISPLAY,
    PHONE_TEL,
    WHATSAPP,
} from "../data/content";

export default function Salon() {
    return (
        <section id="salon" data-testid="salon">
            {/* Large photo */}
            <Reveal y={0}>
                <div
                    className="group relative w-full overflow-hidden"
                    style={{ height: "70vh", minHeight: "480px" }}
                >
                    <img
                        src="/photos/img2.webp"
                        alt="Interiorul salonului LadyArt"
                        className="zoomable h-full w-full object-cover"
                        style={{ objectPosition: "50% 40%" }}
                        loading="lazy"
                    />
                    <div
                        className="absolute inset-0"
                        style={{ backgroundColor: "#1f1f1f", opacity: 0.28 }}
                    />
                    <div className="absolute bottom-8 left-6 md:bottom-12 md:left-12">
                        <span
                            className="eyebrow"
                            style={{ color: "rgba(252,251,248,0.8)" }}
                        >
                            Salonul
                        </span>
                        <h2
                            className="mt-3 font-serif font-light leading-none"
                            style={{
                                color: "var(--bg)",
                                fontSize: "clamp(2.6rem, 7vw, 6rem)",
                            }}
                        >
                            Te așteptăm
                        </h2>
                    </div>
                </div>
            </Reveal>

            {/* Details + map */}
            <div className="grid grid-cols-1 md:grid-cols-2">
                <div className="flex flex-col justify-center px-6 py-16 md:px-14 md:py-24">
                    <Reveal>
                        <div
                            className="border-t pt-6"
                            style={{ borderColor: "var(--line)" }}
                        >
                            <span className="eyebrow eyebrow-ink">Adresă</span>
                            <a
                                href={MAPS_URL}
                                target="_blank"
                                rel="noopener noreferrer"
                                data-testid="salon-address"
                                className="mt-3 block font-serif text-2xl font-light md:text-3xl"
                            >
                                {ADDRESS}
                            </a>
                        </div>
                    </Reveal>

                    <Reveal delay={0.08}>
                        <div
                            className="mt-10 border-t pt-6"
                            style={{ borderColor: "var(--line)" }}
                        >
                            <span className="eyebrow eyebrow-ink">Program</span>
                            <div className="mt-4 flex flex-col gap-2">
                                {HOURS.map((h) => (
                                    <div
                                        key={h.day}
                                        className="flex items-baseline justify-between font-sans"
                                    >
                                        <span className="text-sm">{h.day}</span>
                                        <span
                                            className="font-serif text-xl"
                                            style={{ color: "var(--accent)" }}
                                        >
                                            {h.time}
                                        </span>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </Reveal>

                    <Reveal delay={0.16}>
                        <div
                            className="mt-10 border-t pt-6"
                            style={{ borderColor: "var(--line)" }}
                        >
                            <span className="eyebrow eyebrow-ink">Telefon</span>
                            <a
                                href={PHONE_TEL}
                                data-testid="salon-phone"
                                className="mt-3 block font-serif text-2xl font-light md:text-3xl"
                            >
                                {PHONE_DISPLAY}
                            </a>
                        </div>
                    </Reveal>

                    <Reveal delay={0.24}>
                        <div className="mt-12">
                            <PillButton
                                href={WHATSAPP}
                                external
                                variant="solid"
                                testId="salon-book-btn"
                            >
                                Programează-te
                            </PillButton>
                        </div>
                    </Reveal>
                </div>

                {/* Map */}
                <div
                    className="p-6 md:p-10"
                    style={{ backgroundColor: "var(--bg-2)" }}
                >
                    <div
                        className="h-full overflow-hidden rounded-[20px]"
                        style={{
                            boxShadow: "0 24px 60px -30px rgba(31,31,31,0.35)",
                            border: "1px solid var(--line)",
                        }}
                    >
                        <iframe
                            title="Harta LadyArt"
                            src={MAPS_EMBED}
                            data-testid="salon-map"
                            className="h-full min-h-[380px] w-full"
                            style={{ border: 0, filter: "grayscale(0.35)" }}
                            loading="lazy"
                            referrerPolicy="no-referrer-when-downgrade"
                        />
                    </div>
                </div>
            </div>
        </section>
    );
}
